import { useState, useCallback } from 'react';
import { isAiConfigured } from '../services/aiService';

export const AI_NO_KEY_MSG = 'Kein KI API-Key. Bitte unter Einstellungen → Integrationen → KI-Assistent einen Key von Anthropic oder OpenAI hinterlegen.';

/** Gemeinsamer Hook für KI-Aktionen in der UI */
export function useAiAction() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const configured = isAiConfigured();

  const run = useCallback(async (fn) => {
    if (!isAiConfigured()) {
      setError(AI_NO_KEY_MSG);
      return null;
    }
    setLoading(true);
    setError('');
    try {
      return await fn();
    } catch (e) {
      setError(e?.message || 'KI-Fehler');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearError = useCallback(() => setError(''), []);

  return { loading, error, configured, run, clearError, setError };
}
